<template>
<div>
	<Breadcrumb :title="'Transfer Report'"></Breadcrumb>
	<TransferForm :ref="'TransferInfoForm'" :ProgramUnitClassJsonData="ProgramUnitClassJsonData" 
	:TransferInfo="TransferJSON" :TransferModalLabel="modalConfig" :isCorrection="true"></TransferForm>
	<div>
		<BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
	</div>
	<div class='btnDiv'>
		<BaseToolBar @buttonClicked="onToolBarClick" :config="ToolBarConfig"></BaseToolBar>
	</div>
	<div>
		<BaseGrid :mode="'editform'" :excelExport="excelExport" :config="config" :query="config.query" :colorizeColumn=true
		 @CorrectItem="CorrectTransfer"
		 @AttachItem="AttachmentIconClick"></BaseGrid>
	</div>
	<TransferDocumentDropoffForm ref="transferDocument" 
        :docModalConfig="docModalConfig" 
        :filterCondition="filterCondition"
        :transactionRecord="selectedTransfer"
    ></TransferDocumentDropoffForm>
</div>
</template>

<script>
import $ from 'jquery';
import { GridConfig , ToolBarConfig } from "./TransferReportConfig.js";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";

import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';
//forms
import TransferDocumentDropoffForm from "@/components/forms/TransferDocumentDropoffForm.vue";
import TransferForm from "@/components/forms/TransferForm.vue";


export default {
	name: "TransferReport",
	mixins: [apiUtil, funcUtil, toolbarUtility],
	computed:{
    ...mapGetters("getModule",["withFilter"])
    },
	components: {
		Breadcrumb,
		BaseGrid,
		BaseSearchBar,
		BaseToolBar,
		TransferDocumentDropoffForm,
		TransferForm,
	},
	data: function () {
		return {
			ToolBarConfig: ToolBarConfig,
			config: GridConfig,
			search: {
				SearchData:"",
			},
			TransferMasterData: {},
		// Document dropoff modal
			docModalConfig: {
			modalName: "Transfer Documents",
			modalIdandRef: "docModal",
			isFooter: false
			},
			// Filter condition for Document dropoff modal
			filterCondition: {
			filter: "",
			limit: 500
			}, 
			TransferJSON: {},
			selectedTransfer:{},
			ProgramUnitClassJsonData:{
                option :[],
                unitType:[],
                unitPool:[]
			},
			modalConfig: {
                modalName: "",
                modalAddorEdit: ""
			},
			 BaseModelUnitClass:BaseModelUnitClass,     
		}
	},
	methods: {
		filterGrid() {
			let self = this;
			let currentMasterdata = this.TransferMasterData;
			let filteredData = this._filterGrid(
				this.TransferMasterData,
				this.search.SearchData
			);
			$("#TransferReportGrid")
				.data("kendoGrid")
				.dataSource.data(filteredData);
			this.UpdateTransferMasterData(true, currentMasterdata);
		},
		UpdateTransferMasterData: function(fromFilter, filterMasterData) {
			if (fromFilter == true) {
				this.TransferMasterData = filterMasterData;
			} else {
				this.TransferMasterData = $("#TransferReportGrid")
				.data()
				.kendoGrid.dataSource.data();
			}
		},
		onToolBarClick: function(e) {
			e.preventDefault();
			switch (e.id) {
				case "btnBulkAttachment":
                    this.AttachBatchDocuments();
                    break;
			}
			this._baseToolBarEvents("TransferReportGrid", ...arguments);
		},
		AttachmentIconClick(e){
			let self = this;
            e.preventDefault();
            const gview = window.$("#TransferReportGrid").data("kendoGrid");
            const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

            this.selectedTransfer= {...dataItem};
            //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
            this.selectedTransfer.PartnerTitle=dataItem.ReceiverFullName,
			this.selectedTransfer.PartnerId=dataItem.ReceiverId
			this.selectedTransfer.TransactionID=dataItem.Id

			//this.filterCondition.filter = `BusinessEvent eq 'Transfer' and TransactionID eq ${dataItem.Id}`;
			this.filterCondition.batchQuery=true;

            let BatchGUIDArray=self.GetBatchGUIDArray(this.selectedTransfer.BatchGUID);

            this.filterCondition.filter = function(o){
                return o.BusinessEvent=='Transfer' && (o.TransactionID == dataItem.Id || BatchGUIDArray.includes(o.BatchGUID))
            }

            this.$refs.transferDocument.$refs.transferDocumentMgr.resetDropZoneGrid(); 

            window.$("#docModal").modal("toggle");
		},
		AttachBatchDocuments(){

            let selectedItem = [];
            let selectedRowCount=0;

            //Get Next Batch Id
            const result = this.withFilter(BaseModelDocument.list,"");
			let batchId = (result.length <= 0) ? 1 : this._getIncrementalID(result,"BatchGUID");
			
			//Partner Program Concatenated List Change
            let programIdlist = new Set();
            let partnerIdList = new Set();

            let grid = $("#TransferReportGrid").data("kendoGrid");
                grid.select().each(function () {
                selectedRowCount++;
                let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
                let tempBatchId = [];
                if (!isNullOrUndefined(selectedDataItem.BatchGUID) && !selectedDataItem.BatchGUID=="") {
                    tempBatchId = selectedDataItem.BatchGUID.split(",");
                }
                tempBatchId.push(batchId);
                selectedDataItem.BatchGUID = tempBatchId.toString();

				selectedItem.push(selectedDataItem);
				programIdlist.add(selectedDataItem.ProgramId);
				partnerIdList.add(selectedDataItem.ReceiverId);
				partnerIdList.add(selectedDataItem.SenderId);
                });

            if (selectedRowCount<=1) {
                this._AlertPopup("Please Select Atleast 2 Rows","info");
            }else{
                const batchConfig = {
                Transfer: {
                config: GridConfig,
                updateData: selectedItem
                }
                };

                this.selectedTransfer={};
                this.selectedTransfer.ProgramId=null
				this.selectedTransfer.PartnerId=null
				this.selectedTransfer.ProgramIdList=[...programIdlist].toString();
                this.selectedTransfer.PartnerIdList=[...partnerIdList].toString();
                this.selectedTransfer.TransactionID=null
                this.selectedTransfer.BusinessEvent="Transfer"
                this.selectedTransfer.Type="batch"
                this.selectedTransfer.BatchGUID=batchId;
                this.selectedTransfer.batchConfig=batchConfig
                this.selectedTransfer.parentGridId="TransferReportGrid"

                this.filterCondition.batchQuery=false;

                this.filterCondition.filter = `BusinessEvent eq 'Transfer' and BatchGUID eq ${
                batchId
            }`;
            
            this.$refs.transferDocument.$refs.transferDocumentMgr.resetDropZoneGrid();

            window.$("#docModal").modal("toggle");
                
            }  
		},
		 CorrectTransfer: function(e) {
            let self = this;
            e.preventDefault();
            this.modalConfig.modalName = "Correct Transfer";
            this.modalConfig.modalAddorEdit = "edit";
            //alert("Edit button clicked from BaseGrid..");
            let gview = window.$("#TransferReportGrid").data("kendoGrid");
            // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
            let dataItem = JSON.parse(
                JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
            );
            //  alert(JSON.stringify(dataItem));
            //dataItem.TreasuryUnits = 500; // Hardcoded value for demo

			this.TransferEditJSON = dataItem ;
			if(this.TransferEditJSON.WorkflowStatus !="Correction Pending")
			{
				let unitClassQuery = { filter: "ProgramId eq " + dataItem.ProgramId }
            this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, unitClassQuery)

            this.TransferJSON = this.TransferEditJSON;

            //this.$refs.TransferInfoForm.AvailableUnits = 0;
            this.$refs.TransferInfoForm.calculateAvailableUnits(this.TransferJSON);
            window.$("#BaseModal").modal("toggle");
			}
			else
			{
				this._AlertPopup("Correction Pending.Any further changes can be made in correction page.","info");  
			}

            
            
        },
	},
	mounted(){

		let self = this;
    	let grid = $("#TransferReportGrid").data("kendoGrid");
		grid.bind("dataBound", self.UpdateTransferMasterData);
		grid.dataSource.fetch();
	
		$("#TransferReportFromDate").kendoDatePicker({
			change(e) {
				let value = this.value();
				let toDate = $("#TransferReportToDate")
				.data("kendoDatePicker")
				.value();
				self._filterDatabyDate(grid, value, toDate,"TransactionDate");
			}
			});
		$("#TransferReportToDate").kendoDatePicker({
			change(e) {
				let value = this.value();
				let fromDate = $("#TransferReportFromDate")
				.data("kendoDatePicker")
				.value();
				self._filterDatabyDate(grid, fromDate, value,"TransactionDate");
			}
			});

		// var currentDate = new Date();
        // var start = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 2);
        // var end = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 20);
        // var max = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 60);
		
		// $("#daterangepicker").kendoDateRangePicker({
		// 	range: [start, end],
		// 	change(e) {
		// 		console.log(this._range);
		// 		self._filterDatabyDate(grid, this._range.start, this._range.end);
		// 	}
        // });
			
		//Grid Settings	
		this._loadGridSettings('TransferReportGrid');
	}
	
}
</script>

<style>
#daterangepicker{
	background: #E5E5E5;
	border: 0;
}
</style>

